<h2 mat-dialog-title>{{ data.title || 'Potwierdzenie' }}</h2>
<mat-dialog-content>
  @if (data.messageComponent) {
    <ng-container *ngComponentOutlet="data.messageComponent"></ng-container>
  } @else {
    @if (data.html) {
      <div [innerHTML]="data.html"></div>
    } @else {
      <p>{{ data.message || 'Czy na pewno chcesz wykonać tę operację?' }}</p>
    }
  }
</mat-dialog-content>
<mat-dialog-actions >
  @if (!data.hideCancel) {
    <button class="custom-button"  (click)="onCancel()">Anuluj</button>
  }
  <button mat-raised-button class="custom-button" (click)="onConfirm()">
    {{ data.okLabel || 'OK' }}
  </button>
</mat-dialog-actions>